<template>
  <div id="container" v-loading.fullscreen="disabled">
    <div class="full_layout">
      <div class="shopping_cart">
        <!-- checkout pay -->
        <div class="checkout_box">
          <h3>{{$t('base.payWith')}}</h3>
          <ul class="pay_list">
              <li v-if="item.LowerName!='other'" :class="checkPay==item.LowerName?'on':''" @click="payCheck(item)" v-for="(item,index) in payChannelsList" :key="index">
                <el-image class="like_img" :src="payChannels[item.LowerName]" fit="contain"></el-image>
              </li>
          </ul>
        </div>
        <div class="checkout_box">
          <h3>{{$t('base.ChargeAmount')}}</h3>
          <div class="list_chp">
            <div v-for="(item,index) in list" :key="index" :class="input==item.ID?'on':''" @click="input=item.ID">
              <div>{{item.Money}} {{$t('base.CHP')}}</div>
            </div>
          </div>
          <!-- <div class="chp_num">$<el-input class="detail_ipt chp_ipt" v-model.number="input" type="number" @keydown.native="e=>e.returnValue=(['e','E','-','+'].includes(e.key))?false:e.returnValue" oninput="if(value>=10**3){value=value.slice(0,6)};if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+6)}"></el-input>
          </div> -->
          <el-button class="check_btn" type="primary" @click='pay' :disabled="disabled">{{$t('base.confirm')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo, goPay,GetWorldUSD, setPayList } from "@/api/public";
export default {
  name: 'index',
  data() {
    return {
      userInfo: '',
      checkPay: 'stripe',
      checkPayUpper: 'Stripe',
      payChannelsList: [],
      payChannels: this.$enumInfo.payChannels,
      payEnum: this.$enumInfo.paylist,
      IsGuarantee: 6,
      input: "0",
      list: '',
      disabled: false,

    }
  },
  mounted() {},
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('base.charge'));
    this.userInfo = getInfo()
    if(this.userInfo){
      GetWorldUSD()
      this.isPayChannels()
      this.getpaylist()
    }else{
      this.$router.push({path:'/login'})
    }
  },
  methods: {
    isPayChannels(){
      let that=this
      let data = { areaCode: that.userInfo.MemberSource }
      that.$get(that.$interface.GetPayChannels,data).then(res=>{
        if(res.Result!=0){
          let data = res.Data
          data=data.filter(item=>{
            return (item.ChannelName!='Other')
          })
          data = setPayList(data, that.userInfo, 'mpay')
          data = setPayList(data, that.userInfo, 'usdt')
          that.checkPay = data[0].LowerName
          that.checkPayUpper = data[0].ChannelName
          that.IsGuarantee = that.payEnum[that.checkPay]
          that.payChannelsList = data
        }else{
          that.checkPay = 'stripe'
          that.checkPayUpper = 'Stripe'
          that.IsGuarantee = that.payEnum[that.checkPay]
        }
      }).catch(res=>{
          that.checkPay = 'stripe'
          that.checkPayUpper = 'Stripe'
          that.IsGuarantee = that.payEnum[that.checkPay]
      })
    },
    payCheck(val) {
      let that = this
      this.checkPay = val.LowerName;
      this.checkPayUpper = val.ChannelName;
      this.IsGuarantee = this.payEnum[val.LowerName]
    },
    getpaylist() {
      let that = this
      let data = { deviceType: 1 }
      this.$get(this.$interface.GetCHPList, data).then(res => {
        if (res.result != 0) {
          that.list = res.data;
          that.input = res.data[0].ID
        }
      })
    },
    pay() {
      this.disabled = true
      //goPay('Cpay', ('?Consumeid=' + this.input + "&memberid=" + this.userInfo.MappingUserId))
      if (this.checkPay == 'stripe') {
      goPay('Cpay', ('?Consumeid=' + this.input + "&memberid=" + this.userInfo.MappingUserId))
      }else{
      //goPay('Cpaypal', ('?paysource=1&Consumeid=' + this.input + "&memberid=" + this.userInfo.MappingUserId))
      goPay('Cpaypal', ('&Id=' + this.input + "&memberid=" + this.userInfo.MappingUserId))
      }
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/paycart.css";

.shopping_cart {
  margin: 40px 0;
}

.checkout_box h3 {
  font-size: 24px;
  line-height: 1;
  margin: 0 0 16px;
  display: flex;
}

.checkout_box h3>span {
  font-size: 14px;
  margin-top: 9px;
  margin-left: 12px;
  cursor: pointer;
}

.pay_list {
  display: flex;
  flex-wrap: wrap;
}

.pay_list li {
  border: 1px solid #c8c8c8;
  position: relative;
  cursor: pointer;
  width: 185px;
  margin-right: 20px;
  margin-bottom: 25px;
  height: 38px;
  text-align: center;
}

.pay_list li .like_img {
  width: 100px;
  height: 24px;
  margin-top: 8px;
}

.pay_list li.on {
  border-color: #5F6DAE;
  background: #F0F3FF;
}

.pay_list li.on:before {
  content: "";
  border: 1px solid #fff;
  border-top: none;
  border-left: none;
  width: 3px;
  height: 6px;
  position: absolute;
  transform: rotate(45deg);
  bottom: 3px;
  right: 3px;
  z-index: 2;
}

.pay_list li.on::after {
  content: "";
  border: 10px solid transparent;
  position: absolute;
  border-bottom-color: #5F6DAE;
  border-right-color: #5F6DAE;
  right: -1px;
  bottom: -1px;
}

.chp_ipt {
  width: 144px;
  font-size: 32px;
  font-weight: bold;
}

.chp_num {
  width: 152px;
  border-bottom: 1px solid #e0e0e0;
}

.check_btn {
  margin-top: 40px;
  width: auto;
}

.list_chp {
  display: flex;
}

.list_chp>div {
  width: 150px;
  overflow: hidden;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  line-height: 50px;
  text-align: center;
  margin-right: 25px;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  position: relative;
}

.list_chp>div.on {
  border-color: #5F6DAE;
  background-color: #F0F3FF;
}

.list_chp>div.on:before {
  content: "";
  border: 1px solid #fff;
  border-top: none;
  border-left: none;
  width: 3px;
  height: 6px;
  position: absolute;
  transform: rotate(45deg);
  bottom: 3px;
  right: 3px;
  z-index: 2;
}

.list_chp>div.on::after {
  content: "";
  border: 10px solid transparent;
  position: absolute;
  border-bottom-color: #5F6DAE;
  border-right-color: #5F6DAE;
  right: -1px;
  bottom: -1px;
}


.review_items{
  display: grid;
  grid-template-columns:40% repeat(auto-fit, minmax(90px, 1fr));
  gap: 10px;
  text-align: center;
    min-height: 48px;
    align-items: center;
}
.table_head {
  background-color: #f7f7f7;
  border-bottom: 1px solid #e0e0e0;
}

.review_list {
  align-items: baseline;
  margin-top: 20px;
  grid-template-columns: 52% repeat(auto-fit, minmax(90px, 1fr));
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/chpcheckout.vue